import React from 'react';
import { Image } from 'react-datocms';
import { useDispatchUi } from '@/context/ui';
import Button from '../ReusableUI/Button';
import StructuredText from "../ReusableUI/StructuredText";
import LargeButton from '../Views/Buttons';
import { SectionHeading } from '../Views/Heading';
import { ComponentProps } from "../component";
import { MUZOLOGY_SIGNUP_URL } from '@/lib/defaults';

interface Props {
    id?: string;
    component?: ComponentProps;
    className?: string;
    background?: string;

    heading?: string;
    content?: any;
    featuredImage?: any;
    videoLink?: string;
    ctaVideoButton?: boolean;
    pricingURL?: string;

    ctaSignupButton?: string;
    ctaSignupButtonClass?: string;
    removeVideoButton?: boolean;

    pricingCTA?: string;
    pricingClassName?: string;
}

function isSVGImage(image: string) {
    return image.endsWith('.svg');
}

const ContentSection2 = ({ id, component, background, className, pricingURL, pricingCTA, pricingClassName, removeVideoButton, ctaSignupButton, ctaSignupButtonClass }: Props) => {
    const { heading, content, contentClassName, featuredImage, videoLink, ctaVideoButton, extraData } = component;
    const { featuredImageIpadMedley = false, backgroundBlobs = false } = extraData || {};

    const headingCenter = null;
    const headingLeftColumn = null;
    const headingRightColumn = null;

    const dispatch: any = useDispatchUi();
    return (
        <section id={id}>
            <div className={`default-px default-py w-full font-Inter ${className}`} style={{ background }}>
                <div className='my-0 mx-auto flex flex-col lg:flex-row gap-6 items-center justify-center default-max-w'>
                    <div className='w-full h-full relative'>
                        {backgroundBlobs && <div className='z-10 bg-no-repeat bg-center bg-contain absolute left-0 right-0 top-[-16%] bottom-[-40%] bg-[url("/backgrounds/background-blobs.png")] ' />}

                        <SectionHeading
                            text={heading}
                            // text='MUZOLOGY BY THE NUMBERS'
                            className='[textAlign:center] relative z-50 whitespace-pre-line sm:whitespace-normal lg:whitespace-pre-line text-MuzologyDarkPurple'
                        />

                        <div className='hidden lg:flex z-20 relative w-full my-0 mx-auto items-center justify-center max-w-[640px]'>
                            {featuredImage && (
                                isSVGImage(featuredImage.url) ? <img src={featuredImage?.url} alt={featuredImage?.alt ?? featuredImage?.title} loading='lazy' />
                                    : <Image data={{ ...featuredImage.responsiveImage, bgColor: '#ffffff00' }} />
                            )}
                        </div>
                    </div>

                    <div className='w-full flex flex-col z-30 lg:pb-12 md:pb-0'>
                        <div className='pr-0 lg:pr-8'>
                            <StructuredText
                                data={content}
                                className={contentClassName}
                            />

                            {/*
                            <SmallHeading smallHeading={smallHeading} />
                            <LargeHeading heading={heading} className='text-left' />
                            <NormalText className='text-left w-full ml-0 mr-auto mt-4 md:mt-8'>{subhead}</NormalText>
                            <NormalText className='text-center w-full mt-8 font-bold'>Try it free with your child.</NormalText>
                            */}
                        </div>
                        <div className='flex justify-center lg:justify-start mt-2 md:mt-7 w-full'>
                            <div className='button-group'>
                                <LargeButton
                                    id={id + '-start-free-trial'}
                                    href={MUZOLOGY_SIGNUP_URL}
                                    // className={`${ctaSignupButtonClass ?? 'dark-orange-button'} w-[210px] uppercase`}
                                    // text={ctaSignupButton ?? 'Start Free Trial'}
                                    className={`${ctaSignupButtonClass ?? 'dark-orange-button'} w-[230px] uppercase`}
                                    text={ctaSignupButton ?? 'Start Free Trial'}
                                />
                                {(!removeVideoButton) && <LargeButton
                                    id={id + '-how-it-works'}
                                    className='blue-button w-[230px] uppercase'
                                    onClick={() => dispatch({ type: 'PLAY_VIDEO', payload: videoLink })}
                                    text='Teachers Love It'
                                    rightDelta={true}
                                />}
                                {/*
                                <SmallerText className='w-auto font-[500] 2xl:text-[16px] text-center mt-4 mb-0 absolute left-[25%] bottom-[-38px] whitespace-nowrap transform translate-x-[-50%]'>
                                    {ctaButtonSubtext}
                                </SmallerText>
                                */}
                            </div>

                            {ctaVideoButton && (
                                <div className='ml-4'>
                                    <Button id={id + '-watch-video'} className='dark-button'>
                                        <div className='flex items-center justify-start py-0.5'>
                                            <div className='text-white px-4 text-base  font-medium'>Watch Video</div>
                                            <div className='mt-1'>
                                                <svg xmlns='http://www.w3.org/2000/svg' width='15' height='20' fill='none'>
                                                    <path
                                                        fill='#FFFCFC'
                                                        fillRule='evenodd'
                                                        d='M0 2v16a1 1 0 0 0 1.524.852l13-8a1 1 0 0 0 0-1.704l-13-8A1 1 0 0 0 0 2Zm2 1.79L12.091 10 2 16.21V3.79Z'
                                                        clipRule='evenodd'
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContentSection2;
